import bmkg from "../bmkg.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <div className="flex absolute left-0 py-1 bottom-0 px-3 min-[370px]:py-0 opacity-80  min-[370px]:bg-white z-10 items-center gap-2 shadow-lg border">
      <img alt="bmkg" src={bmkg} className="w-3" />
      <span className="hidden min-[370px]:block text-[10px] min-[520px]:text-xs">
        Data From{" "}
        <button
          onClick={() => window.open("https://data.bmkg.go.id/", "_blank")}
          className="font-medium text-sky-600 hover:text-sky-500"
        >
          BMKG
        </button>{" "}
      </span>
      <span className="hidden min-[520px]:block text-xs">
        - &copy; {year}, ZEN
      </span>
    </div>
  );
}
